import { useEffect, useState } from "react";
import {
  Button,
  TextField,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Tag } from "antd";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Refresh } from "@mui/icons-material";

const CommissionTopBar = ({
  setOpen = () => {},
  setFilters = () => {},
  summary = {},
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);
  // const [paid, setPaid] = useState(false);

  const handleSearchChange = (e) => {
    const value = e?.target?.value || "";
    setSearchValue(value);
  };

  const handleFilterTypeChange = (event) => {
    const value = event?.target?.value || "";
    setFilterType(value);
    const newDate = value === "all" ? null : selectedMonthYear;
    setSelectedMonthYear(newDate);
  };

  const handleMonthYearChange = (value) => {
    setSelectedMonthYear(value);
  };

  // const handleCheckBoxChange = (e) => {
  //   setPaid(e?.target?.checked);
  // };

  useEffect(() => {
    setFilters({ search: searchValue, filterType, selectedMonthYear });
  }, [searchValue, filterType, selectedMonthYear]);

  return (
    <div className="flex items-center justify-between mb-4 px-4 py-2 border rounded-md shadow-sm">
      <div className="flex items-center">
        <Tag color="blue">
          <span className="text-sm font-medium">
            Records: <strong>{`${summary?.records || 0}`}</strong>
          </span>
        </Tag>

        <Tag color="green">
          <span className="text-sm font-medium">
            Total:{" "}
            <strong>{`$${
              Number(summary?.summary?.total)?.toFixed(2) || 0
            }`}</strong>
          </span>
        </Tag>

        <Tag color="cyan">
          <span className="text-sm font-medium">
            Received:{" "}
            <strong>{`$${
              Number(summary?.summary?.received)?.toFixed(2) || 0
            }`}</strong>
          </span>
        </Tag>

        <Tag color="volcano">
          <span className="text-sm font-medium">
            Pending:{" "}
            <strong>{`$${
              Number(summary?.summary?.pending).toFixed(2) || 0
            }`}</strong>
          </span>
        </Tag>
      </div>

      <div className="flex items-center gap-2">
        {/* <FormControlLabel
          control={<Checkbox checked={paid} onChange={handleCheckBoxChange} />}
          label="Paid"
        /> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="filter-type-label">Filter</InputLabel>
            <Select
              labelId="filter-type-label"
              value={filterType}
              label="Filter"
              onChange={handleFilterTypeChange}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="custom">Custom Date</MenuItem>
            </Select>
          </FormControl>
          <DatePicker
            views={["year", "month"]}
            label="Month & Year"
            value={selectedMonthYear}
            onChange={handleMonthYearChange}
            disabled={filterType !== "custom"}
            slotProps={{ textField: { size: "small", sx: { width: 180 } } }}
          />
        </LocalizationProvider>

        <TextField
          size="small"
          label="Search"
          variant="outlined"
          value={searchValue}
          onChange={handleSearchChange}
          sx={{ width: 200 }}
        />

        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={() => setOpen(true)}
        >
          Add
        </Button>

        <IconButton
          size="small"
          onClick={() => {
            setSearchValue("");
            setFilterType("all");
            setSelectedMonthYear(null);
            // setPaid(false);
            setFilters({
              search: "",
              filterType: "all",
              selectedMonthYear: null,
              paid: false,
            });
          }}
        >
          <Refresh />
        </IconButton>

        {/* <Button
          variant="contained"
          size="small"
          color="secondary"
          startIcon={<UploadFileIcon />}
        >
          Import
        </Button> */}
      </div>
    </div>
  );
};

export default CommissionTopBar;
